import styled,{createGlobalStyle , css }  from 'styled-components'

const flexCenter = css`
    display:flex;
    justify-content:space-between;
    align-items:center;
`;
export const FirstSectionWrap = styled.section`
    height:416px;
    background: #007aff;
    .flexSpaceBetween{
        display:flex;
        justify-content:space-between;
        align-items:center;
    }
    img{
        margin-right:50px
    }
`;
export const Block = styled.div`
    width:1200px;
    margin:0 auto;
`;

export const BlockTitle = styled.h1`
    font-size: 36px;
    font-weight: bold;
    color: #fff;
    margin-left:50px;
`;

export const BlockSlogan = styled.p`
    font-size: 28px;
    color: #ffffff;
    margin-top: 20px;
    margin-left:50px;
`;

export const BlockHead = styled.div`
    font-size: 26px;
    font-weight: bold;
    text-align: center;
    color: #15213c;
    margin:74px 0;
`;

export const BlockBody = styled.div`
    background: #fff;
    box-shadow: 0px 6px 30px 0px #e6e6f0; 
    box-sizing:border-box;
    padding:51px 49px;
    margin-bottom:60px;
    .brandInfo{
        ${flexCenter};
        align-items:flex-start;
        margin-bottom:40px;
    }
    .info{
        width:890px;
        font-size: 14px;
        color: rgba(21,33,60,0.80);
        line-height: 26px;
    }
`;

export const CaseIcon = styled.i`
    display:inline-block;
    padding-right:27px;
    border-right: 1px solid #e9e9e9;
    img{
        width: 162px;
        height: 73px;
    }
`;

export const About = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 349px;
    a{
        width: 193px;
        height: 66px;
        background: #007aff;
        border-radius: 8px;
        color: #fff;
        font-size: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    span{
        font-size: 20px;
        color: #15213c;
        margin-top: 45px;
        margin-bottom: 10px;
    }
    img{
        width:132px;
    }
`;